export default __webpack_public_path__ + "static/media/Slide22.607789cf.jpg";